import React from 'react';
import styled from 'styled-components';
import Button from '../../common/Button';
import { Modal, Row, Col } from 'antd';
import CheckIcon from '../../../assets/img/checkmark.svg';
import './style.css';

const ConfirmSignupModal = ({ open, close }) => {
  return (
    <Modal className="signup__modal" visible={open} footer={null}>
      <div>
        <Row>
          <Col span={24}>
            <img src={CheckIcon} alt="" />
          </Col>
          <Col span={24}>
            <h3 className="heading">You've Successfully Created an Account</h3>
            <p>Proceed to signin</p>
          </Col>

          <div className="footer">
            <Button appearance="blue" size="small" onClick={close}>
              OK
            </Button>
          </div>
        </Row>
      </div>
    </Modal>
  );
};

export default ConfirmSignupModal;
